import React, { useEffect } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import useTranslation from '@/utils/hooks/translation/useTranslation';
import useActiveSocialProfile from '@/utils/hooks/user/useActiveSocialProfile';

import useAlbumRefreshBanner from '@/utils/hooks/utils/useAlbumRefreshBanner';

import InfoBanner from '@/components/base/InfoBanner';
import ErrorAnalyticsFallback from '@/components/layouts/ErrorFallbacks/ErrorAnalyticsFallback';
import AnalyticsGrid from '@/components/layouts/wrappers/AnalyticsGrid';

export const AnalyticsWrapper = ({
    periodStart,
    periodEnd,
    period,
    compareTo,
    albumId,
    album,
    children,
    className,
    showRefreshBanner
}) => {
    const { activeSocialProfile } = useActiveSocialProfile();
    const { t } = useTranslation('content');
    const { isVisible, show } = useAlbumRefreshBanner();

    useEffect(() => {
        if (showRefreshBanner) {
            show();
        }
    }, [showRefreshBanner, show]);

    return (
        <ErrorBoundary FallbackComponent={ErrorAnalyticsFallback}>
            {isVisible && (
                <InfoBanner
                    type="info"
                    title={t('campaign_refresh_banner_title')}
                    message={t('campaign_refresh_banner_message')}
                    className="mb-6"
                />
            )}
            <AnalyticsGrid className={className}>
                {React.Children.map(children, (child, index) =>
                    React.cloneElement(child, {
                        // Key based on SP type forces remount when switching between V1/V2 analytics
                        key: `${activeSocialProfile?.social_network_type}-${index}`,
                        activeSocialProfile,
                        periodStart,
                        periodEnd,
                        period,
                        compareTo,
                        albumId,
                        album
                    })
                )}
            </AnalyticsGrid>
        </ErrorBoundary>
    );
};
